import { RateCheckerTableState } from '@/views/rate-checker-configuration/rate-checker-table/rate-checker-table.types';

const state: RateCheckerTableState = {
  tableData: [],
  tableHeader: [],
};

export default state;
